(function() {
  'use strict';

  /* ── Price tiers (from Shopify variants) ── */
  var TIERS = [
    { length: 12, price: 10.99, vid: '48361159557361' },
    { length: 18, price: 13.99, vid: '48361159590129' },
    { length: 24, price: 16.99, vid: '48361159622897' },
    { length: 36, price: 22.99, vid: '48361159655665' },
    { length: 48, price: 28.99, vid: '48361159688433' },
    { length: 60, price: 39.99, vid: '48361159721201' },
    { length: 72, price: 44, vid: '48361159753969' },
    { length: 84, price: 50, vid: '48361159786737' },
    { length: 96, price: 56, vid: '48361159819505' },
    { length: 108, price: 62, vid: '48361159852273' },
    { length: 120, price: 68, vid: '48361159885041' },
    { length: 144, price: 90, vid: '48361159917809' },
    { length: 180, price: 105, vid: '48361159950577' },
    { length: 216, price: 120, vid: '48361159983345' },
    { length: 240, price: 130, vid: '48361160016113' },
    { length: 264, price: 140, vid: '48361160048881' },
    { length: 288, price: 160, vid: '48361160081649' },
    { length: 360, price: 190, vid: '48361160114417' }
  ];

  var SHEET_W = 22;
  var gap = 0.25;           // default margin (adjustable)
  var PREVIEW_SCALE = 20;
  var EXPORT_DPI = 150;
  var nextId = 1;
  var designs = [];
  var selectedId = null;    // currently selected design
  var refreshTimer = null;  // debounce timer for input events

  /* ── DOM refs ── */
  var dropZone, fileInput, designList, canvas, ctx;
  var priceEl, sizeEl, lengthEl, countEl, addBtn, emptyMsg, previewWrap;
  var marginInput, addMoreBtn;

  /* ── Init ── */
  function init() {
    dropZone    = document.getElementById('gsb-drop');
    fileInput   = document.getElementById('gsb-file');
    designList  = document.getElementById('gsb-designs');
    canvas      = document.getElementById('gsb-canvas');
    ctx         = canvas.getContext('2d');
    priceEl     = document.getElementById('gsb-price');
    sizeEl      = document.getElementById('gsb-size');
    lengthEl    = document.getElementById('gsb-length');
    countEl     = document.getElementById('gsb-count');
    addBtn      = document.getElementById('gsb-cart');
    emptyMsg    = document.getElementById('gsb-empty');
    previewWrap = document.getElementById('gsb-preview-wrap');
    marginInput = document.getElementById('gsb-margin');
    addMoreBtn  = document.getElementById('gsb-add-more');

    if (!dropZone) return;

    /* Drop zone events */
    dropZone.addEventListener('click', function() { fileInput.click(); });
    fileInput.addEventListener('change', function(e) {
      handleFiles(e.target.files);
      fileInput.value = '';
    });
    dropZone.addEventListener('dragover', function(e) {
      e.preventDefault(); e.stopPropagation();
      dropZone.classList.add('gsb-drag-over');
    });
    dropZone.addEventListener('dragleave', function(e) {
      e.preventDefault(); e.stopPropagation();
      dropZone.classList.remove('gsb-drag-over');
    });
    dropZone.addEventListener('drop', function(e) {
      e.preventDefault(); e.stopPropagation();
      dropZone.classList.remove('gsb-drag-over');
      handleFiles(e.dataTransfer.files);
    });

    /* Add More button */
    if (addMoreBtn) {
      addMoreBtn.addEventListener('click', function() { fileInput.click(); });
    }

    /* Margin control */
    if (marginInput) {
      marginInput.addEventListener('change', function() {
        gap = parseFloat(this.value) || 0.25;
        if (gap < 0) gap = 0;
        if (gap > 2) gap = 2;
        this.value = gap;
        refresh();
      });
    }

    /* Add to cart */
    addBtn.addEventListener('click', addToCart);

    refresh();
  }

  /* ── Handle uploaded files ── */
  function handleFiles(fileList) {
    for (var i = 0; i < fileList.length; i++) {
      var f = fileList[i];
      if (!f.type.match(/image\/(png|jpe?g|svg|tiff?|webp)/i) &&
          !f.name.match(/\.(png|jpe?g|svg|tiff?|webp|pdf|ai|eps|psd)$/i)) {
        continue;
      }
      loadDesign(f);
    }
  }

  function loadDesign(file) {
    var id = nextId++;
    var reader = new FileReader();
    reader.onload = function(e) {
      var img = new Image();
      img.onload = function() {
        var defaultW = 4;
        var aspect = img.naturalHeight / img.naturalWidth;
        var defaultH = Math.round(defaultW * aspect * 10) / 10;
        if (defaultH > 20) { defaultH = 20; defaultW = Math.round(20 / aspect * 10) / 10; }
        if (defaultW > 21) { defaultW = 21; defaultH = Math.round(21 * aspect * 10) / 10; }

        /* Calculate DPI quality */
        var dpiW = img.naturalWidth / defaultW;
        var dpiH = img.naturalHeight / defaultH;
        var dpi = Math.round(Math.min(dpiW, dpiH));

        designs.push({
          id: id, file: file, img: img,
          name: file.name.replace(/\.[^.]+$/, ''),
          wIn: defaultW, hIn: defaultH, qty: 1,
          aspect: aspect,
          locked: true,
          dpi: dpi,
          naturalW: img.naturalWidth,
          naturalH: img.naturalHeight,
          bgRemoved: false
        });
        selectedId = id;
        refresh();
      };
      img.src = e.target.result;
    };
    reader.readAsDataURL(file);
  }

  /* ── Remove design ── */
  function removeDesign(id) {
    designs = designs.filter(function(d) { return d.id !== id; });
    if (selectedId === id) selectedId = designs.length > 0 ? designs[0].id : null;
    refresh();
  }

  /* ── Duplicate design ── */
  function duplicateDesign(id) {
    var src = designs.find(function(d) { return d.id === id; });
    if (!src) return;
    var newId = nextId++;
    designs.push({
      id: newId, file: src.file, img: src.img,
      name: src.name + ' (copy)',
      wIn: src.wIn, hIn: src.hIn, qty: src.qty,
      aspect: src.aspect, locked: src.locked,
      dpi: src.dpi, naturalW: src.naturalW, naturalH: src.naturalH,
      bgRemoved: src.bgRemoved
    });
    selectedId = newId;
    refresh();
  }

  /* ── Toggle aspect lock ── */
  function toggleLock(id) {
    var d = designs.find(function(x) { return x.id === id; });
    if (!d) return;
    d.locked = !d.locked;
    if (d.locked) {
      d.aspect = d.hIn / d.wIn;
    }
    refresh();
  }

  /* ── Remove Background (flood-fill from edges) ── */
  function removeBackground(id) {
    var d = designs.find(function(x) { return x.id === id; });
    if (!d) return;

    /* Update button to show processing state */
    var btn = document.querySelector('[data-rmbg="' + id + '"]');
    if (btn) {
      btn.disabled = true;
      btn.innerHTML = '⏳ <span>Removing...</span>';
    }

    var tmpCanvas = document.createElement('canvas');
    var w = d.img.naturalWidth;
    var h = d.img.naturalHeight;
    tmpCanvas.width = w;
    tmpCanvas.height = h;
    var tctx = tmpCanvas.getContext('2d', { willReadFrequently: true });
    tctx.drawImage(d.img, 0, 0, w, h);

    var imageData = tctx.getImageData(0, 0, w, h);
    var data = imageData.data;
    var tolerance = 40;

    /* Sample background color from corners (average of corner pixels) */
    var corners = [
      [0, 0], [w - 1, 0], [0, h - 1], [w - 1, h - 1],
      [1, 0], [0, 1], [w - 2, 0], [w - 1, 1],
      [0, h - 2], [1, h - 1], [w - 2, h - 1], [w - 1, h - 2]
    ];
    var bgR = 0, bgG = 0, bgB = 0, bgCount = 0;
    corners.forEach(function(c) {
      var idx = (c[1] * w + c[0]) * 4;
      bgR += data[idx];
      bgG += data[idx + 1];
      bgB += data[idx + 2];
      bgCount++;
    });
    bgR = Math.round(bgR / bgCount);
    bgG = Math.round(bgG / bgCount);
    bgB = Math.round(bgB / bgCount);

    /* Flood fill from all edge pixels */
    var visited = new Uint8Array(w * h);
    var queue = [];

    /* Seed from all 4 edges */
    for (var x = 0; x < w; x++) {
      queue.push(x + 0 * w);
      queue.push(x + (h - 1) * w);
    }
    for (var y = 0; y < h; y++) {
      queue.push(0 + y * w);
      queue.push((w - 1) + y * w);
    }

    function isBackground(idx4) {
      var r = data[idx4], g = data[idx4 + 1], b = data[idx4 + 2], a = data[idx4 + 3];
      if (a < 10) return true; /* already transparent */
      var dr = r - bgR, dg = g - bgG, db = b - bgB;
      return Math.sqrt(dr * dr + dg * dg + db * db) < tolerance;
    }

    /* BFS flood fill — process in chunks to avoid blocking UI */
    var head = 0;
    function processChunk() {
      var limit = head + 100000;
      while (head < queue.length && head < limit) {
        var pos = queue[head++];
        if (visited[pos]) continue;
        var px = pos % w;
        var py = (pos - px) / w;
        var idx4 = pos * 4;
        if (!isBackground(idx4)) continue;
        visited[pos] = 1;
        data[idx4 + 3] = 0; /* make transparent */

        /* Add neighbors */
        if (px > 0 && !visited[pos - 1]) queue.push(pos - 1);
        if (px < w - 1 && !visited[pos + 1]) queue.push(pos + 1);
        if (py > 0 && !visited[pos - w]) queue.push(pos - w);
        if (py < h - 1 && !visited[pos + w]) queue.push(pos + w);
      }

      if (head < queue.length) {
        requestAnimationFrame(processChunk);
      } else {
        /* Done — apply anti-aliasing on edges */
        for (var i = 0; i < w * h; i++) {
          if (visited[i]) continue;
          var ix = i % w;
          var iy = (i - ix) / w;
          /* Check if any neighbor is transparent (edge pixel) */
          var hasTransparent = false;
          if (ix > 0 && visited[i - 1]) hasTransparent = true;
          if (ix < w - 1 && visited[i + 1]) hasTransparent = true;
          if (iy > 0 && visited[i - w]) hasTransparent = true;
          if (iy < h - 1 && visited[i + w]) hasTransparent = true;
          if (hasTransparent) {
            /* Partially fade edge pixels */
            var i4 = i * 4;
            var dist = Math.sqrt(
              Math.pow(data[i4] - bgR, 2) +
              Math.pow(data[i4 + 1] - bgG, 2) +
              Math.pow(data[i4 + 2] - bgB, 2)
            );
            if (dist < tolerance * 1.5) {
              var alpha = Math.min(255, Math.round((dist / (tolerance * 1.5)) * 255));
              data[i4 + 3] = Math.min(data[i4 + 3], alpha);
            }
          }
        }

        tctx.putImageData(imageData, 0, 0);

        /* Create new image from processed canvas */
        var newImg = new Image();
        newImg.onload = function() {
          d.img = newImg;
          d.bgRemoved = true;
          refresh();
        };
        newImg.src = tmpCanvas.toDataURL('image/png');
      }
    }
    requestAnimationFrame(processChunk);
  }

  /* ── Auto Fill Sheet — fill the current sheet with copies of a design ── */
  function autoFillSheet(id) {
    var d = designs.find(function(x) { return x.id === id; });
    if (!d) return;

    var packed = packDesigns();
    var tier = findTier(packed.totalLength || 12);

    var cols = Math.floor((SHEET_W + gap) / (d.wIn + gap));
    var rows = Math.floor((tier.length + gap) / (d.hIn + gap));
    var maxFit = cols * rows;

    var currentTotal = d.qty;
    if (maxFit > currentTotal) {
      d.qty = maxFit;
      refresh();
    }
  }

  /* ── Update design property (no re-render, just data + preview) ── */
  function updateDesignSilent(id, prop, val) {
    var d = designs.find(function(x) { return x.id === id; });
    if (!d) return;

    if (prop === 'wIn' || prop === 'hIn') {
      val = parseFloat(val);
      if (isNaN(val) || val === 0) return; /* let user keep typing */
      if (val < 0.5) val = 0.5;
      if (val > (prop === 'wIn' ? 21.5 : 350)) val = prop === 'wIn' ? 21.5 : 350;
      d[prop] = val;

      if (d.locked) {
        if (prop === 'wIn') {
          d.hIn = Math.round(val * d.aspect * 10) / 10;
          if (d.hIn < 0.5) d.hIn = 0.5;
          if (d.hIn > 350) d.hIn = 350;
          /* Update the paired input without full re-render */
          var hInput = document.querySelector('input[data-id="' + id + '"][data-prop="hIn"]');
          if (hInput) hInput.value = d.hIn;
        } else {
          d.wIn = Math.round(val / d.aspect * 10) / 10;
          if (d.wIn < 0.5) d.wIn = 0.5;
          if (d.wIn > 21.5) d.wIn = 21.5;
          var wInput = document.querySelector('input[data-id="' + id + '"][data-prop="wIn"]');
          if (wInput) wInput.value = d.wIn;
        }
      } else {
        d.aspect = d.hIn / d.wIn;
      }

      /* Recalculate DPI */
      var dpiW = d.naturalW / d.wIn;
      var dpiH = d.naturalH / d.hIn;
      d.dpi = Math.round(Math.min(dpiW, dpiH));

      /* Update DPI badge inline */
      var dpiInfo = getDpiInfo(d.dpi);
      var card = document.querySelector('.gsb-card input[data-id="' + id + '"]');
      if (card) {
        var cardEl = card.closest('.gsb-card');
        var badge = cardEl ? cardEl.querySelector('.gsb-dpi-badge') : null;
        if (badge) {
          badge.style.background = dpiInfo.bg;
          badge.style.color = dpiInfo.color;
          badge.textContent = dpiInfo.label + ' (' + d.dpi + ' DPI)';
        }
        var ratioEl = cardEl ? cardEl.querySelector('.gsb-ratio') : null;
        if (ratioEl) ratioEl.textContent = d.aspect.toFixed(2);
      }
    } else if (prop === 'qty') {
      val = parseInt(val);
      if (isNaN(val) || val === 0) return;
      if (val < 1) val = 1;
      if (val > 100) val = 100;
      d[prop] = val;
    }

    /* Only refresh preview + stats, not cards */
    refreshPreviewOnly();
  }

  /* ── Update design property (full, used on blur/change) ── */
  function updateDesign(id, prop, val) {
    var d = designs.find(function(x) { return x.id === id; });
    if (!d) return;

    if (prop === 'wIn' || prop === 'hIn') {
      val = parseFloat(val) || 1;
      if (val < 0.5) val = 0.5;
      if (val > (prop === 'wIn' ? 21.5 : 350)) val = prop === 'wIn' ? 21.5 : 350;
      d[prop] = val;

      if (d.locked) {
        if (prop === 'wIn') {
          d.hIn = Math.round(val * d.aspect * 10) / 10;
          if (d.hIn < 0.5) d.hIn = 0.5;
          if (d.hIn > 350) d.hIn = 350;
        } else {
          d.wIn = Math.round(val / d.aspect * 10) / 10;
          if (d.wIn < 0.5) d.wIn = 0.5;
          if (d.wIn > 21.5) d.wIn = 21.5;
        }
      } else {
        d.aspect = d.hIn / d.wIn;
      }

      var dpiW = d.naturalW / d.wIn;
      var dpiH = d.naturalH / d.hIn;
      d.dpi = Math.round(Math.min(dpiW, dpiH));
    } else if (prop === 'qty') {
      val = parseInt(val) || 1;
      if (val < 1) val = 1;
      if (val > 100) val = 100;
      d[prop] = val;
    }
    refresh();
  }

  /* ── DPI quality indicator ── */
  function getDpiInfo(dpi) {
    if (dpi >= 300) return { label: 'Optimal', color: '#059669', bg: '#ecfdf5' };
    if (dpi >= 250) return { label: 'Good', color: '#d97706', bg: '#fffbeb' };
    if (dpi >= 200) return { label: 'Fair', color: '#ea580c', bg: '#fff7ed' };
    return { label: 'Low', color: '#dc2626', bg: '#fef2f2' };
  }

  /* ── Shelf bin-packing ── */
  function packDesigns() {
    var items = [];
    designs.forEach(function(d) {
      for (var q = 0; q < d.qty; q++) {
        items.push({ designId: d.id, w: d.wIn, h: d.hIn, img: d.img });
      }
    });
    items.sort(function(a, b) { return b.h - a.h; });

    var placements = [];
    var shelves = [];

    items.forEach(function(item) {
      var placed = false;
      var iw = item.w + gap;
      for (var s = 0; s < shelves.length; s++) {
        if (shelves[s].xUsed + iw <= SHEET_W + gap) {
          placements.push({
            designId: item.designId, img: item.img,
            x: shelves[s].xUsed, y: shelves[s].y, w: item.w, h: item.h
          });
          shelves[s].xUsed += iw;
          placed = true;
          break;
        }
      }
      if (!placed) {
        var newY = 0;
        if (shelves.length > 0) {
          var last = shelves[shelves.length - 1];
          newY = last.y + last.height + gap;
        }
        shelves.push({ y: newY, height: item.h, xUsed: item.w + gap });
        placements.push({
          designId: item.designId, img: item.img,
          x: 0, y: newY, w: item.w, h: item.h
        });
      }
    });

    var totalLength = 0;
    if (shelves.length > 0) {
      var last = shelves[shelves.length - 1];
      totalLength = last.y + last.height;
    }
    return { placements: placements, totalLength: Math.ceil(totalLength) };
  }

  /* ── Find best tier ── */
  function findTier(neededLength) {
    for (var i = 0; i < TIERS.length; i++) {
      if (TIERS[i].length >= neededLength) return TIERS[i];
    }
    return TIERS[TIERS.length - 1];
  }

  /* ── Render preview canvas ── */
  function renderPreview(packed) {
    var tier = findTier(packed.totalLength || 12);
    var sheetH = tier.length;
    var cw = SHEET_W * PREVIEW_SCALE;
    var ch = sheetH * PREVIEW_SCALE;

    canvas.width = cw;
    canvas.height = ch;
    canvas.style.width = '100%';
    canvas.style.maxWidth = cw + 'px';

    ctx.fillStyle = '#ffffff';
    ctx.fillRect(0, 0, cw, ch);

    /* Checkered background for transparency */
    var checkSize = PREVIEW_SCALE / 2;
    for (var cx = 0; cx < cw; cx += checkSize) {
      for (var cy = 0; cy < ch; cy += checkSize) {
        if ((Math.floor(cx / checkSize) + Math.floor(cy / checkSize)) % 2 === 0) {
          ctx.fillStyle = '#f5f5f5';
          ctx.fillRect(cx, cy, checkSize, checkSize);
        }
      }
    }

    /* Grid lines every inch */
    ctx.strokeStyle = 'rgba(0,0,0,0.06)';
    ctx.lineWidth = 0.5;
    for (var x = 0; x <= SHEET_W; x++) {
      ctx.beginPath(); ctx.moveTo(x * PREVIEW_SCALE, 0);
      ctx.lineTo(x * PREVIEW_SCALE, ch); ctx.stroke();
    }
    for (var y = 0; y <= sheetH; y++) {
      ctx.beginPath(); ctx.moveTo(0, y * PREVIEW_SCALE);
      ctx.lineTo(cw, y * PREVIEW_SCALE); ctx.stroke();
    }

    /* Sheet border */
    ctx.strokeStyle = '#aaa';
    ctx.lineWidth = 2;
    ctx.strokeRect(1, 1, cw - 2, ch - 2);

    /* Used area indicator */
    if (packed.totalLength > 0) {
      ctx.fillStyle = 'rgba(168, 24, 48, 0.04)';
      ctx.fillRect(0, 0, cw, packed.totalLength * PREVIEW_SCALE);
      ctx.strokeStyle = 'rgba(168, 24, 48, 0.4)';
      ctx.lineWidth = 1;
      ctx.setLineDash([5, 5]);
      ctx.beginPath();
      ctx.moveTo(0, packed.totalLength * PREVIEW_SCALE);
      ctx.lineTo(cw, packed.totalLength * PREVIEW_SCALE);
      ctx.stroke();
      ctx.setLineDash([]);
    }

    /* Draw designs with DPI-based borders */
    packed.placements.forEach(function(p) {
      var px = p.x * PREVIEW_SCALE;
      var py = p.y * PREVIEW_SCALE;
      var pw = p.w * PREVIEW_SCALE;
      var ph = p.h * PREVIEW_SCALE;

      var d = designs.find(function(x) { return x.id === p.designId; });
      var dpiInfo = d ? getDpiInfo(d.dpi) : getDpiInfo(300);
      var isSelected = d && d.id === selectedId;

      try { ctx.drawImage(p.img, px + 1, py + 1, pw - 2, ph - 2); } catch(e) {}

      /* DPI-colored border */
      ctx.strokeStyle = isSelected ? '#a81830' : dpiInfo.color;
      ctx.lineWidth = isSelected ? 3 : 2;
      ctx.strokeRect(px, py, pw, ph);

      /* Size label */
      ctx.fillStyle = 'rgba(0,0,0,0.7)';
      ctx.font = 'bold 9px system-ui, sans-serif';
      var label = p.w + '"×' + p.h + '"';
      var tw = ctx.measureText(label).width;
      ctx.fillStyle = 'rgba(255,255,255,0.85)';
      ctx.fillRect(px + 2, py + 2, tw + 6, 14);
      ctx.fillStyle = '#333';
      ctx.fillText(label, px + 5, py + 13);
    });

    /* Ruler labels */
    ctx.fillStyle = '#888';
    ctx.font = '10px system-ui, sans-serif';
    ctx.fillText('22"', cw / 2 - 8, ch - 3);
    ctx.save();
    ctx.translate(cw - 3, ch / 2);
    ctx.rotate(-Math.PI / 2);
    ctx.fillText(sheetH + '"', -10, 0);
    ctx.restore();
  }

  /* ── Refresh preview + stats only (no card re-render) ── */
  function refreshPreviewOnly() {
    if (designs.length === 0) return;
    var totalDesigns = 0;
    designs.forEach(function(d) { totalDesigns += d.qty; });

    var packed = packDesigns();
    var tier = findTier(packed.totalLength || 1);
    renderPreview(packed);

    priceEl.textContent = '$' + tier.price.toFixed(2);
    sizeEl.textContent = '22" x ' + tier.length + '"';
    lengthEl.textContent = packed.totalLength + '"';
    countEl.textContent = totalDesigns.toString();
    addBtn.disabled = false;
    addBtn.textContent = 'ADD TO CART — $' + tier.price.toFixed(2);
  }

  /* ── Render design cards ── */
  function renderCards() {
    designList.innerHTML = '';
    designs.forEach(function(d) {
      var card = document.createElement('div');
      card.className = 'gsb-card' + (d.id === selectedId ? ' gsb-card-selected' : '');

      var lockIcon = d.locked ? '🔒' : '🔓';
      var lockTitle = d.locked ? 'Proportional — click to unlock' : 'Free resize — click to lock';
      var lockClass = d.locked ? 'gsb-lock-btn gsb-locked' : 'gsb-lock-btn gsb-unlocked';
      var dpiInfo = getDpiInfo(d.dpi);
      var ratioText = d.aspect.toFixed(2);

      var bgBtnText = d.bgRemoved ? '✅ Background Removed' : '🔲 Remove Background';
      var bgBtnClass = d.bgRemoved ? 'gsb-card-rmbg gsb-rmbg-done' : 'gsb-card-rmbg';

      card.innerHTML =
        '<div class="gsb-card-thumb" data-select="' + d.id + '">' +
          '<img src="' + d.img.src + '" alt="' + d.name + '">' +
        '</div>' +
        '<div class="gsb-card-info">' +
          '<div class="gsb-card-header">' +
            '<div class="gsb-card-name">' + d.name + '</div>' +
            '<span class="gsb-dpi-badge" style="background:' + dpiInfo.bg + ';color:' + dpiInfo.color + '" title="' + d.dpi + ' DPI">' + dpiInfo.label + ' (' + d.dpi + ' DPI)</span>' +
          '</div>' +
          '<div class="gsb-card-fields">' +
            '<label>W <input type="number" value="' + d.wIn + '" min="0.5" max="21.5" step="0.5" data-id="' + d.id + '" data-prop="wIn"> in</label>' +
            '<button class="' + lockClass + '" data-lock="' + d.id + '" title="' + lockTitle + '">' + lockIcon + '</button>' +
            '<label>H <input type="number" value="' + d.hIn + '" min="0.5" max="350" step="0.5" data-id="' + d.id + '" data-prop="hIn"> in</label>' +
            '<span class="gsb-ratio" title="Aspect ratio">' + ratioText + '</span>' +
            '<label>Qty <input type="number" value="' + d.qty + '" min="1" max="100" step="1" data-id="' + d.id + '" data-prop="qty"></label>' +
          '</div>' +
        '</div>' +
        '<div class="gsb-card-actions">' +
          '<button class="' + bgBtnClass + '" data-rmbg="' + d.id + '" title="Remove Background"><span>' + bgBtnText + '</span></button>' +
          '<button class="gsb-card-autofill" data-fill="' + d.id + '" title="Auto Fill Sheet">🔲 <span>Auto Fill</span></button>' +
          '<button class="gsb-card-duplicate" data-dup="' + d.id + '" title="Duplicate">📋 <span>Duplicate</span></button>' +
          '<button class="gsb-card-remove" data-remove="' + d.id + '" title="Remove">&times; <span>Remove</span></button>' +
        '</div>';

      /* Event listeners for inputs — only update on change (blur/enter), NOT on every keystroke */
      card.querySelectorAll('input').forEach(function(inp) {
        /* On change (blur or enter) — full refresh */
        inp.addEventListener('change', function() {
          updateDesign(parseInt(this.dataset.id), this.dataset.prop, this.value);
        });
        /* On input (typing) — debounced preview-only update, NO card re-render */
        inp.addEventListener('input', function() {
          var self = this;
          clearTimeout(refreshTimer);
          refreshTimer = setTimeout(function() {
            updateDesignSilent(parseInt(self.dataset.id), self.dataset.prop, self.value);
          }, 400);
        });
        /* On Enter key — commit immediately */
        inp.addEventListener('keydown', function(e) {
          if (e.key === 'Enter') {
            clearTimeout(refreshTimer);
            this.blur(); /* triggers change event */
          }
        });
      });

      var lockBtn = card.querySelector('[data-lock]');
      if (lockBtn) {
        lockBtn.addEventListener('click', function(e) {
          e.preventDefault();
          e.stopPropagation();
          toggleLock(parseInt(this.dataset.lock));
        });
      }

      /* Remove Background button */
      var rmbgBtn = card.querySelector('[data-rmbg]');
      if (rmbgBtn) {
        rmbgBtn.addEventListener('click', function(e) {
          e.preventDefault();
          var dId = parseInt(this.dataset.rmbg);
          var dd = designs.find(function(x) { return x.id === dId; });
          if (dd && dd.bgRemoved) return; /* already done */
          removeBackground(dId);
        });
      }

      var fillBtn = card.querySelector('[data-fill]');
      if (fillBtn) {
        fillBtn.addEventListener('click', function(e) {
          e.preventDefault();
          autoFillSheet(parseInt(this.dataset.fill));
        });
      }

      var dupBtn = card.querySelector('[data-dup]');
      if (dupBtn) {
        dupBtn.addEventListener('click', function(e) {
          e.preventDefault();
          duplicateDesign(parseInt(this.dataset.dup));
        });
      }

      var removeBtn = card.querySelector('[data-remove]');
      if (removeBtn) {
        removeBtn.addEventListener('click', function(e) {
          e.preventDefault();
          removeDesign(parseInt(this.dataset.remove));
        });
      }

      /* Select card on click */
      var thumbEl = card.querySelector('[data-select]');
      if (thumbEl) {
        thumbEl.addEventListener('click', function() {
          selectedId = parseInt(this.dataset.select);
          refresh();
        });
      }

      designList.appendChild(card);
    });
  }

  /* ── Master refresh ── */
  function refresh() {
    var totalDesigns = 0;
    designs.forEach(function(d) { totalDesigns += d.qty; });

    renderCards();

    /* Show/hide Add More button, DPI legend, and controls */
    if (addMoreBtn) {
      addMoreBtn.style.display = designs.length > 0 ? 'flex' : 'none';
    }
    var dpiLegend = document.getElementById('gsb-dpi-legend');
    var controls = document.getElementById('gsb-controls');
    if (dpiLegend) dpiLegend.style.display = designs.length > 0 ? 'block' : 'none';
    if (controls) controls.style.display = designs.length > 0 ? 'flex' : 'none';

    if (designs.length === 0) {
      emptyMsg.style.display = 'block';
      previewWrap.style.display = 'none';
      addBtn.disabled = true;
      addBtn.textContent = 'ADD TO CART';
      priceEl.textContent = '$0.00';
      sizeEl.textContent = '--';
      lengthEl.textContent = '0"';
      countEl.textContent = '0';
      return;
    }

    emptyMsg.style.display = 'none';
    previewWrap.style.display = 'block';

    var packed = packDesigns();
    var tier = findTier(packed.totalLength || 1);

    renderPreview(packed);

    priceEl.textContent = '$' + tier.price.toFixed(2);
    sizeEl.textContent = '22" x ' + tier.length + '"';
    lengthEl.textContent = packed.totalLength + '"';
    countEl.textContent = totalDesigns.toString();
    addBtn.disabled = false;
    addBtn.textContent = 'ADD TO CART — $' + tier.price.toFixed(2);
  }

  /* ── Generate composite & add to cart ── */
  function addToCart() {
    if (designs.length === 0) return;
    addBtn.disabled = true;
    addBtn.textContent = 'BUILDING GANG SHEET...';

    var packed = packDesigns();
    var tier = findTier(packed.totalLength || 1);

    var scale = EXPORT_DPI;
    var expW = SHEET_W * scale;
    var expH = tier.length * scale;
    if (expH > 32000) {
      scale = Math.floor(32000 / tier.length);
      expW = SHEET_W * scale;
      expH = tier.length * scale;
    }

    var expCanvas = document.createElement('canvas');
    expCanvas.width = expW;
    expCanvas.height = expH;
    var ectx = expCanvas.getContext('2d');

    ectx.fillStyle = '#ffffff';
    ectx.fillRect(0, 0, expW, expH);

    packed.placements.forEach(function(p) {
      try { ectx.drawImage(p.img, p.x * scale, p.y * scale, p.w * scale, p.h * scale); } catch(e) {}
    });

    expCanvas.toBlob(function(blob) {
      if (!blob) {
        alert('Error generating gang sheet. Please try again.');
        addBtn.disabled = false;
        refresh();
        return;
      }

      var desc = 'Sheet: 22" x ' + tier.length + '" | Margin: ' + gap + '"\n';
      designs.forEach(function(d) {
        desc += d.name + ': ' + d.wIn + '" x ' + d.hIn + '" (qty ' + d.qty + ') [' + d.dpi + ' DPI]\n';
      });

      var formData = new FormData();
      formData.append('id', tier.vid);
      formData.append('quantity', '1');
      formData.append('properties[Gang Sheet File]', blob, 'gang-sheet-' + Date.now() + '.png');
      formData.append('properties[Layout Details]', desc.trim());
      formData.append('properties[Built With]', 'Gang Sheet Builder');

      fetch('/cart/add.js', { method: 'POST', body: formData })
      .then(function(res) {
        if (!res.ok) throw new Error('Cart error ' + res.status);
        return res.json();
      })
      .then(function() {
        addBtn.textContent = '✓ ADDED TO CART';
        setTimeout(function() { window.location.href = '/cart'; }, 800);
      })
      .catch(function(err) {
        console.error('Cart error:', err);
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            id: parseInt(tier.vid), quantity: 1,
            properties: { 'Layout Details': desc.trim(), 'Built With': 'Gang Sheet Builder',
              '_note': 'Customer will email gang sheet file' }
          })
        })
        .then(function(res) { if (!res.ok) throw new Error('Fallback error'); return res.json(); })
        .then(function() {
          addBtn.textContent = '✓ ADDED TO CART';
          alert('Added to cart! Please email your gang sheet file to Sales@PrintingNeedle.com with your order number.');
          setTimeout(function() { window.location.href = '/cart'; }, 500);
        })
        .catch(function() {
          alert('Something went wrong. Please try again or contact us at (714) 766-4601.');
          addBtn.disabled = false;
          refresh();
        });
      });
    }, 'image/png');
  }

  /* ── Start ── */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
